import { render, staticRenderFns } from "./WorkIconSave.vue?vue&type=template&id=2f2bcb54"
import script from "./WorkIconSave.vue?vue&type=script&lang=js"
export * from "./WorkIconSave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports